import { render, staticRenderFns } from "./OurNavCol.vue?vue&type=template&id=bbbf6014&"
import script from "./OurNavCol.vue?vue&type=script&lang=js&"
export * from "./OurNavCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports